import {useEffect} from 'react';

export const useAppEventListen = (event: string, listener: () => void) => {
  useEffect(() => {
    const listenerCache = listener;
    window.addEventListener(event, listenerCache);
    return () => {
      window.removeEventListener(event, listenerCache);
    };
  }, [event, listener]);
};
